import type { ROLE } from 'services/assist-api/entities/role/roles';

/**
 * The context used by PageAccessProvider and AreaAccessProvider. An AuthorisableUser and
 * AuthorisableArea should always be defined, even in cases when these aren't loaded yet or are not
 * relevant to the current context. This is for type safety reasons (so that the authorisation
 * policies that consume these objects always have defined objects passed to them).
 */
export const accessContext = {
  authorisableUser: {
    roles: [] as ROLE[]
  },
  userMinusSiteAdmin: {
    roles: [] as ROLE[]
  },
  authorisableArea: {}, // Must be defined so that policy "record" params can be required types.
  isLoading: true // Set to false once all dependencies of authorisableUser have loaded.
};
